const words = ["Leagues", "Catch logs", "Leaderboards", "Seasons", "Rivalries", "Trophies"];

export const Marquee = () => {
  const row = [...words, ...words];
  return (
    <section aria-hidden="true" data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-cyan-400/10 bg-[#0A101D] py-6 sm:py-8">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center">
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center font-display text-5xl sm:text-7xl font-black uppercase tracking-tight">
                <span className={i % 2 ? "text-outline" : "text-white"}>{w}</span>
                <span className="mx-8 inline-block h-3 w-3 rotate-45 bg-[#F59E0B]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
